import React from 'react';

import LikePost from '@src/api/LikePost';
import UnlikePost from '@src/api/UnlikePost';
import useAuthenticationTokens from '@src/hooks/useAuthenticationTokens';

const useLike = (id?: string, status?: boolean, likesCount?: number) => {
  const [liked, setLiked] = React.useState(status);
  const [count, setCount] = React.useState(0);

  const {
    tokens: { accessToken },
  } = useAuthenticationTokens();

  React.useLayoutEffect(() => setCount(likesCount ?? 0), [likesCount]);

  const handleLike = React.useCallback(async () => {
    if (!id) {
      return;
    }
    if (liked) {
      try {
        setLiked(false);
        setCount(count - 1);
        await UnlikePost(accessToken, { entityId: id }, { timeout: 2000 });
      } catch (e) {
        console.log(e);
        setCount(count + 1);
        setLiked(true);
      }
    } else {
      try {
        setLiked(true);
        setCount(count + 1);
        await LikePost(accessToken, { entityId: id }, { timeout: 2000 });
      } catch (e) {
        console.log(e);
        setCount(count - 1);
        setLiked(false);
      }
    }
  }, [accessToken, count, id, liked]);
  return React.useMemo(
    () => ({
      handleLike,
      liked,
      likesCount: count,
    }),
    [count, handleLike, liked]
  );
};

export default useLike;
